

function ChromeError(errCode, errMsg) {
    this.errCode = errCode;
    this.errMsg = errMsg;
}

const urlNotExist = new ChromeError('CE001'," url is not exist");

// 请求失败，可能是url错误
const requestError = new ChromeError('CE002',"request failed");

// 请求失败，非200响应码
const httpStatusIsNotNormal = new ChromeError('CE003',"http status is not 200");

// 业务异常
const businessError = new ChromeError('CE004',"business handle failed");

export default {urlNotExist,requestError,httpStatusIsNotNormal,businessError}




